import React from 'react';
import { Coordinate } from '@usepepper/ui/molecules/map/types';
import { ImperativeOverlayView } from '@usepepper/ui/molecules/map/imperative-overlay-view';

const DOT_SIZE = 10;
const HALO_SIZE = 24;

const BLUE = '#4285f4';

const haloStyle: React.CSSProperties = {
  alignItems: 'center',
  background: `${BLUE}26`,
  borderRadius: '50%',
  display: 'flex',
  height: HALO_SIZE,
  justifyContent: 'center',
  transform: 'translate(-50%, -50%)',
  width: HALO_SIZE,
};

const dotStyle: React.CSSProperties = {
  background: BLUE,
  border: '1.5px solid #fff',
  borderRadius: '50%',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.35)',
  height: DOT_SIZE,
  width: DOT_SIZE,
};

interface Props {
  coordinate: Coordinate;
}

export const UserLocationDot: React.FC<Props> = ({ coordinate }) => (
  <ImperativeOverlayView
    position={{ lat: coordinate.latitude, lng: coordinate.longitude }}
  >
    <div aria-hidden style={haloStyle}>
      <div style={dotStyle} />
    </div>
  </ImperativeOverlayView>
);
